/* DTFJOKER — live countdown to the daily production cutoff.
   Deferred, dependency-free. Reuses Dawn's announcement markup; only fills
   the [data-dtfj-countdown] targets, so slide rotation logic stays untouched. */
(function () {
  'use strict';

  function init() {
    var targets = document.querySelectorAll('[data-dtfj-countdown]');
    if (!targets.length) return;

    // Cutoff lives on the nearest ancestor carrying [data-dtfj-cutoff]
    // (the shipping bar), falling back to the timer element itself.
    var host = targets[0].closest('[data-dtfj-cutoff]') || targets[0];
    var cutoff = host.getAttribute('data-dtfj-cutoff') || '15:00';
    var parts = cutoff.split(':');
    var cutH = parseInt(parts[0], 10);
    var cutM = parseInt(parts[1], 10) || 0;
    if (isNaN(cutH)) cutH = 15;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    // The cutoff is a fixed US Eastern time, not the visitor's local clock.
    // Without this, a shopper in Los Angeles sees "5 hours left" when the
    // Eastern cutoff has already passed. toLocaleString with a timeZone gives
    // us "now" as it reads in New York; DST is handled by the browser.
    var CUTOFF_TZ = host.getAttribute('data-dtfj-tz') || 'America/New_York';

    function nowInZone() {
      return new Date(new Date().toLocaleString('en-US', { timeZone: CUTOFF_TZ }));
    }

    // Remaining milliseconds until the next cutoff. Both sides of the
    // subtraction are shifted by the same offset, so the difference is real.
    function msRemaining() {
      var zoneNow = nowInZone();
      var t = new Date(zoneNow.getTime());
      t.setHours(cutH, cutM, 0, 0);
      if (t.getTime() <= zoneNow.getTime()) t.setDate(t.getDate() + 1);
      return t.getTime() - zoneNow.getTime();
    }

    // Cache the per-unit boxes (hours/minutes/seconds) for each target.
    var groups = [];
    for (var t = 0; t < targets.length; t++) {
      groups.push({
        root: targets[t],
        h: targets[t].querySelector('[data-dtfj-h]'),
        m: targets[t].querySelector('[data-dtfj-m]'),
        s: targets[t].querySelector('[data-dtfj-s]')
      });
    }

    function tick() {
      var diff = msRemaining();
      var total = Math.floor(diff / 1000);
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      var hh = pad(h), mm = pad(m), ss = pad(s);
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        if (g.h) g.h.textContent = hh;
        if (g.m) g.m.textContent = mm;
        if (g.s) g.s.textContent = ss;
        // keep the <time> machine-readable for accessibility
        g.root.setAttribute('datetime', 'PT' + h + 'H' + m + 'M' + s + 'S');
      }
    }

    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
